export default function ArtistProfileAboutTab({ content }) {
    return (
      <div className="mt-[45px] lg:ml-[111px] lg:mt-[32px] whitespace-pre-line lg:mr-[65px] lg:pl-[100px] lg:pr-[71px] lg:pt-[29px] lg:pb-[41px] ">
        <p className=" font-[500] lg:text-[26px] leading-[22px] lg:leading-[40px] tracking-[0.13px] text-[#E5E5EA] ">
          {content?.length == 0 || !content ? "No Bio Added" : content}
        </p>
      </div>
    );
}